<ds-modal [modalInput]="modalConfig" (visibleChange)="onModalVisibleChange($event)">
  <ng-container modal-body>
    <p class="paragraph-12">{{ "smart_import_confirm_suggestions_subtitle" | translate }}</p>

    @if (remainingCount > 0) {
      <div class="primary-info-container --borderless">
        <ul class="ds-info-text --icon-info --info">
          <li>{{ "smart_import_confirm_suggestions_notice" | translate: { count: remainingCount } }}</li>
        </ul>
      </div>
    }

    <div class="page-type-list_on-modal">
      @for (group of groups; track group.id) {
        <div class="page-type-item">
          <div>
            <h6 class="title-14">{{ group.contentTypeLabel }}</h6>
            <p class="paragraph-12 text-placeholder">
              {{ "smart_import_pages_confidence_caption" | translate: { pages: group.pageCount, confidence: group.confidence } }}
            </p>
          </div>
          <div class="--status" [ngClass]="statusClassFor(group)">
            <img [src]="ICONS.BULLET" alt="" /> {{ statusLabelKeyFor(group) | translate }}
          </div>
        </div>
      }
    </div>
  </ng-container>

  <ng-container modal-footer>
    <ds-button [buttonInput]="cancelButtonConfig" (btnClick)="cancelled.emit()"></ds-button>
    <ds-button [buttonInput]="confirmButtonConfig" (btnClick)="confirmed.emit()"></ds-button>
  </ng-container>
</ds-modal>
